import RouteEnum from "constants/RouteEnum";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import CastelectLogo from "../castelect-logo/CastelectLogo";
import "./SideBar.css";
import UserMenu from "./components/UserMenu";

const SideBar: React.FC = () => {
  const [sideBarMod, setSidebar] = useState<boolean>(true);
  const setSideBarMod = () => setSidebar(!sideBarMod);
  const { t } = useTranslation();
  return (
    <div className={sideBarMod ? "fixed-sidebar" : "fixed-sidebar lg-menu-open"}>
      <div className="fixed-sidebar-left small-sidebar">
        <div className="sidebar-toggle">
          <button className="toggle-btn toggler-open" onClick={setSideBarMod}>
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
        <div className="sidebar-menu-wrap">
          <div className="mCustomScrollbar" data-mcs-theme="dark" data-mcs-axis="y">
            <ul className="side-menu">
              <UserMenu showtitle={false} sideBarStatus={sideBarMod} />
            </ul>
          </div>
        </div>
      </div>
      <div className="fixed-sidebar-left large-sidebar">
        <div className="sidebar-toggle">
          <div className="sidebar-logo">
            <CastelectLogo height={28} redirectToPath={RouteEnum.Profile} />
          </div>
          <button className="toggle-btn toggler-close" onClick={setSideBarMod}>
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
        <div className="sidebar-menu-wrap">
          <div className="mCustomScrollbar" data-mcs-theme="dark" data-mcs-axis="y">
            <ul className="side-menu">
              <UserMenu showtitle={true} sideBarStatus={sideBarMod} />
            </ul>
            <ul className="top-menu-mobile">
              <li className="menu-label">
                <NavLink to={RouteEnum.Projects}>
                  {t("menus.nav-top-menu.projects.title")}
                </NavLink>
              </li>
              <li>
                <NavLink className="menu-link" to={RouteEnum.Commercials}>
                  {t("menus.nav-top-menu.projects.commercials")}
                </NavLink>
              </li>
              <li>
                <NavLink className="menu-link" to={RouteEnum.Movies}>
                  {t("menus.nav-top-menu.projects.movies")}
                </NavLink>
              </li>
              <li>
                <NavLink className="menu-link" to={RouteEnum.Series}>
                  {t("menus.nav-top-menu.projects.series")}
                </NavLink>
              </li>
              <li className="menu-label">
                <NavLink to={RouteEnum.Actors}>
                  {t("menus.nav-top-menu.actors.index")}
                </NavLink>
              </li>
              <li className="menu-label company">
                <p>{t("menus.nav-top-menu.companies.index")}</p>
              </li>
              <li>
                <NavLink className="menu-link" to={RouteEnum.Productions}>
                  {t("menus.nav-top-menu.companies.productions")}
                </NavLink>
              </li>
              <li>
                <NavLink className="menu-link" to={RouteEnum.Clients}>
                  {t("menus.nav-top-menu.companies.clients")}
                </NavLink>
              </li>
              <li>
                <NavLink className="menu-link" to={RouteEnum.Casts}>
                  {t("menus.nav-top-menu.companies.agencies")}
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SideBar;
